module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('van-tabs', {
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      attrs: {
        "type": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.row.list.list), function(item, i) {
      return _c('div', [(item.style == '1') ? _c('Activity1', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '2') ? _c('Activity2', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '3') ? _c('Activity3', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '4') ? _c('Activity4', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '5') ? _c('Activity5', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 1), _vm._v(" "), (_vm.sendShow) ? _c('div', {
    staticClass: "comment-bottom"
  }, [_c('div', {
    staticClass: "send-comment"
  }, [_c('van-field', {
    attrs: {
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-btn",
    on: {
      "click": _vm.onCommentSend
    }
  }, [_vm._v("发送")])], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5853f6e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/activity/MyTopic.vue
// module id = 2417
// module chunks = 0